import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active != null)?_c(VTabs,{staticClass:"tabsGeneralStyle",attrs:{"centered":"","grow":_vm.$vuetify.breakpoint.smAndDown,"show-arrows":_vm.$vuetify.breakpoint.xs ? true : false,"value":_vm.active,"color":"secondary"}},_vm._l((_vm.items),function(item){return _c(VTab,{key:item.id,attrs:{"disabled":item.disabled},on:{"click":function($event){return _vm.handleClick($event, item)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }